import { Machine as _Machine } from 'stent';
import { makeConfig } from './config';
/**
 * We have to use a type assertion because Stent library has no type definitions
 */ export const createCartMachine = function() {
    const machineName = `cart_${Date.now()}`;
    // eslint-disable-next-line @typescript-eslint/consistent-type-assertions
    return _Machine.create(machineName, makeConfig());
};
